import { render, staticRenderFns } from "./userPointsMobile.vue?vue&type=template&id=4403db5d"
import script from "./userPointsMobile.vue?vue&type=script&lang=js"
export * from "./userPointsMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports